/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Hydraulic_Coil_Dialog_SubtitleInputs */



/**
* | output |
* | --- |
* | "Edit hydraulic coil association" |
*
* @param {Air_Handler_Unit_Hydraulic_Coil_Dialog_SubtitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_hydraulic_coil_dialog_subtitle = /** @type {((inputs?: Air_Handler_Unit_Hydraulic_Coil_Dialog_SubtitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Hydraulic_Coil_Dialog_SubtitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Edit hydraulic coil association")
	return /** @type {LocalizedString} */ ("Modifier la configuration des batteries hydrauliques")
});